import { createFileRoute } from "@tanstack/react-router";
import PageGate from "@/components/auth/PageGate";
import Social from "@/pages/Social";
import { SocialFeedSkeleton } from "@/components/social/SocialFeedSkeleton";

export const Route = createFileRoute("/_app/social/")({
  // Shows the dark player placeholder straight away instead of keeping the
  // previous page on screen during the switch.
  pendingComponent: SocialFeedSkeleton,
  component: () => (
    <PageGate pageKey="social"><Social /></PageGate>
  ),
});
